import React from 'react';

import { useFormState } from 'react-final-form';

import { Box } from '@vk-hr-tek/ui/Box';
import { Grid } from '@vk-hr-tek/ui/Grid';
import { useInject } from '@vk-hr-tek/core/ioc';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { InputTooltip } from '@vk-hr-tek/ui/InputTooltip';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { DateInput, RadioInput, TextInput } from '@vk-hr-tek/app-ui/form';

import { ANONYMOUS_OPTIONS, SHOW_ANSWERS_OPTIONS } from '../../../constants';

export const SettingsSection = () => {
  const validator = useInject(ValidationService);
  const { values: formValues } = useFormState({
    subscription: { values: true },
  });

  return (
    <Box display="flex" flexDirection="column" gap="16">
      <Typography variant="h6">Настройки</Typography>

      <Box display="flex" flexDirection="column">
        <RadioInput
          name="settings.showAnswers"
          label="Показывать ответы"
          options={SHOW_ANSWERS_OPTIONS}
          debounceTimeout={200}
          tooltip={
            <InputTooltip description="После отправки ответов участники опроса смогут просматривать статистику результатов опроса" />
          }
        />

        <RadioInput
          label="Анонимный опрос"
          name="settings.anonymous"
          options={ANONYMOUS_OPTIONS}
          debounceTimeout={200}
          tooltip={
            <InputTooltip description="Анонимный опрос не будет отображать в результатах участников, которые отправили ответы" />
          }
        />

        <Grid container spacing="16">
          <Grid item xs={12} md={6}>
            <DateInput
              name="settings.completionDate"
              label="Дата завершения опроса"
              validateArray={[
                validator.dateNotInPast(
                  'Выбрана дата в прошлом',
                  'settings.completionDate',
                ),
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextInput
              mask="99:99"
              placeholder="ЧЧ:MM"
              debounceTimeout={200}
              required={!!formValues.settings.completionDate}
              name="settings.completionTime"
              label="Время завершения опроса (GMT+3)"
              validateArray={[
                !!formValues.settings.completionDate
                  ? validator.required('Обязательное поле')
                  : undefined,
                validator.isValidTime('Диапазон значений от 00:00 до 23:59'),
                validator.timeNotInPast(
                  'Выбрано время в прошлом',
                  'settings.completionDate',
                ),
              ]}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
